import "./i18n";
import "./utilities/InternetExplorerPolyfills";
import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import NonSuspendingErrorBoundary from "./components/NonSuspendingErrorBoundary";
import { unregister as unregisterServiceWorker } from "./registerServiceWorker";
import App from "./App";
import { ThemeProvider } from "styled-components";
import { RefreshRouter } from "@sisuwellness/web-components";
import APIClient from "utilities/APIClient";
import theme from "@sisuwellness/web-components/themes";
import configureStore from "@sisuwellness/connected-components/store";
import { Provider } from "react-redux";
import rootReducer from "reducers";
import thunk from "redux-thunk";

const store = configureStore({ rootReducer, middleware: [thunk] });

if (window.Cypress) {
    window.__store__ = store;
}

export const EntryPoint = () => (
    <Provider store={store}>
        <ThemeProvider theme={theme}>
            <RefreshRouter checkForUpdate={() => APIClient.appVersion.getMembersPortalAppVersion()}>
                <App />
            </RefreshRouter>
        </ThemeProvider>
    </Provider>
);

// Create a loading component for Suspense
const Loading = () => (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <p>Loading translations...</p>
    </div>
);

// eslint-disable-next-line
ReactDOM.render(
    <NonSuspendingErrorBoundary>
        <Suspense fallback={<Loading />}>
            <EntryPoint />
        </Suspense>
    </NonSuspendingErrorBoundary>,
    document.getElementById("root")
);

unregisterServiceWorker();
